import React, { Fragment } from 'react';
import { Grid, Button } from 'semantic-ui-react';

const FNButtons = ({ onNext, onBack, onSubmit, showSubmit, disabledNext }) => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <Fragment>
          {showSubmit ? (
            <Button onClick={onSubmit} floated="right" primary>
              Submit
            </Button>
          ) : (
            <Button onClick={onNext} floated="right" primary disabled={disabledNext}>
              Next
            </Button>
          )}
          <Button onClick={onBack} floated="right" color="red">
            Back
          </Button>
        </Fragment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default FNButtons;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/FNButtons.js